<template>
  <page
    v-model:filter="q"
    :name="$t('My hosting')"
    :empty="services.length <= 0"
    :state="servicesState"
  >
    <pf-page-section>
      <pf-data-list>
        <pf-data-list-item v-for="service in filtered" :key="service.dominio"
          :data-ouia-component-id="`service-${service.dominio}`"
        >
          <pf-data-list-cell>
            {{ service.dominio }}
          </pf-data-list-cell>

          <pf-data-list-cell v-if="service.pannello" no-fill>
            <circle-nodes-icon /> {{ titlePannello(service) }}
          </pf-data-list-cell>
          <pf-data-list-cell v-if="service.posta" no-fill>
            <envelope-icon /> {{ $t('Email') }}
          </pf-data-list-cell>
          <pf-data-list-cell v-if="service.pecs" no-fill>
            <envelope-icon /> {{ $t('PEC') }}
          </pf-data-list-cell>
          <pf-data-list-cell v-if="service.dns" no-fill>
            <domain-icon /> {{ $t('Gestione dominio e DNS') }}
          </pf-data-list-cell>
          <pf-data-list-cell v-if="service.redirect !== undefined" no-fill>
            <arrow-icon /> {{ $t('Redirect') }}
          </pf-data-list-cell>
          <pf-data-list-action>
            <granted-link :to="{ name: 'service_detail', params: { domain: service.dominio } }" type="primary" small>
              {{ $t('Dettagli') }}
            </granted-link>
          </pf-data-list-action>
        </pf-data-list-item>
      </pf-data-list>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import GrantedLink from '@/components/granted-link.vue';
import { ServiceResource, type Service } from '@/resources';
import { asyncComputedList } from '@common/asyncComputed';
import { any } from '@common/utils';
import { $t as _t } from '@/i18n';
import { ref, computed } from 'vue';
import CircleNodesIcon from '@vue-patternfly/icons/circle-nodes-icon';
import DomainIcon from '@vue-patternfly/icons/domain-icon';
import ArrowIcon from '@vue-patternfly/icons/arrow-icon';
import EnvelopeIcon from '@vue-patternfly/icons/envelope-icon';

const { result: services, state: servicesState } = asyncComputedList(() => new ServiceResource().get());

const q = ref('');
const filtered= computed (() => services.value.filter(any(q.value)));

function titlePannello (service: Service) {
  return service.pannello && service.posta ? 'Web' : _t('Web / Email');
};
</script>
